import { PhotoService } from './photo.service';

export const services = [
  PhotoService,
];
